import { Row, Switch, styled } from '@teko/ds-desktop';
import { useDistanceTerminalContext } from 'contexts';
import { t } from 'i18n';
import { useGetDistanceTerminal } from '../useGetDistanceTerminal';

export const SwitchGetByGeoLocation = () => {
  const { isGetCurrentLocation, setIsGetCurrentLocation } =
    useDistanceTerminalContext();
  const { requestLocation } = useGetDistanceTerminal();
  return (
    <Row justify="space-between">
      <Title>{t('Bật định vị để tìm siêu thị gần nhất')}</Title>
      <Switch
        checked={isGetCurrentLocation}
        onChange={() => {
          if (isGetCurrentLocation) {
            setIsGetCurrentLocation?.(false);
          } else {
            requestLocation(() => setIsGetCurrentLocation?.(true));
          }
        }}
      />
    </Row>
  );
};

const Title = styled.span`
  font-size: 13;
  font-weight: 700;
  line-height: 24px;
`;
